import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { NavigationError, Router } from '@angular/router';
import { MessageService } from '../message';

@Injectable()
export class AppErrorHandler implements ErrorHandler {

    public constructor(private injector: Injector,
                       private messageService: MessageService,
                       private callBack?: any ) {
        this.handleRouterError();
    }

    public handleError(error: any) {
        this.messageService.hideLoading();

        console.error(error);

        // NavigationError
        if (error.rejection && error.task && error.promise) {
            return;
        }

        if (error instanceof Error) {
            this.unhandledError(error);
            return;
        }
        if (error instanceof HttpErrorResponse) {
            this.handleHttpResponseError( error as HttpErrorResponse);
            return;
        }
    }

    private unhandledError(error: Error) {
        this.messageService.error(error.message.split(' ')[0]);
        this.callBack(error.message.split(' ')[1]);
    }

    // tslint:disable-next-line:cyclomatic-complexity
    private handleHttpResponseError(error: HttpErrorResponse) {
        let currentError: any = error.error;
        if (currentError instanceof Error) {
            this.messageService.error(currentError.message);
            return;
        }
        if (currentError instanceof String || typeof currentError === 'string') {
            try {
                currentError = JSON.parse(currentError.toString());
            } catch (e) {
                //
            }
        }

        if (error.status <= 0) {
            setTimeout(() => {
                const router = this.injector.get(Router);
                router.navigate(['/error/navigation'], {
                    skipLocationChange: true,
                    queryParams: { url: '/', message: 'è¯·æ±apiæ¶åºç°ç½ç»éè¯¯! è¯·æF5é®å·æ°é¡µé¢éè¯!' },
                });
            });
            return;
        }

        if (error.status >= 400) {
            const translate: any = {
                400: 'è¯·æ±éè¯¯',
                401: 'ææè®¤è¯å¤±è´¥',
                403: 'ç¦æ­¢è®¿é®',
                404: 'èµæºæªæ¾å°',
                405: 'ä¸æ¯æè¯¥æä½',
                422: 'è¯·æ±æ°æ®æè¯¯',
                500: 'åé¨æå¡å¨éè¯¯',
                503: 'ç½ç»æé'
            };

            let message = translate[error.status] || 'æªç¥éè¯¯!';
            if (currentError) {
                message = currentError.resultMsg || currentError;
                // if (message.indexOf('<i>Runtime Error</i>') !== -1) {
                //     message = 'è¯·æ±apiæ¶åºç°åé¨æå¡å¨éè¯¯!';
                // }
                if (error.status >= 500) {
                    setTimeout(() => this.messageService.error(message));
                    return;
                }
                if (error.status !== 401) {
                    setTimeout(() => this.messageService.warn(message));
                    return;
                } else {
                    return;
                }
            }
            setTimeout(() => this.messageService.error(message));
            return;
        }
    }

    private handleRouterError() {
        setTimeout(() => {
            const router = this.injector.get(Router);
            router.events.subscribe(event => {
                if (event instanceof NavigationError) {
                    const { url, error } = event as NavigationError;
                    const { message/*, stack*/ } = error;
                    router.navigate(['/error/navigation'], {
                        skipLocationChange: true,
                        queryParams: { url, message: message || error },
                    });
                }
            });
        });
    }
}
